module.exports = __webpack_public_path__ + "static/ClickedOutPatientMedical-0a79f01acc49a0de45b011837cc1a4e8.png";